// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"bee045af","310":"4f4d51b3","370":"8cbd680d","482":"f7fc2dfc","497":"7979d8c8","561":"cccdf82a","889":"2cc62b08"}[chunkId] + ".chunk.js";
};